package com.cybersoftsolution.cybersoftsolutionweb.utils

import com.varabyte.kobweb.browser.dom.observers.ResizeObserver
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.launch
import org.w3c.dom.DOMRectReadOnly
import org.w3c.dom.Element


val contentRectElementObserver = ContentRectElementObserver

object ContentRectElementObserver {
    private val contentSize = MutableSharedFlow<Pair<String, DOMRectReadOnly>>(replay = 1)  // Canal para comunicar cambios
    val contentSizeFlow = contentSize.asSharedFlow()

    private val observers = mutableMapOf<String, ResizeObserver>()
    private val resizeObserver : ResizeObserver = ResizeObserver { entries ->
        entries.forEach { entry ->
            CoroutineScope(Dispatchers.Default).launch {
                contentSize.emit(
                    Pair(entry.target.id, entry.contentRect)
                )
            }
            /**
            entry.contentRect.width: Aquí está la clave para obtener el ancho.
            contentRect es un objeto DOMRectReadOnly que contiene información
            sobre el tamaño y la posición del área de contenido del elemento.
            width es la propiedad que te da el ancho de esa área. Es importante
            notar que contentRect excluye el padding, border y scrollbar.
            Si necesitas incluir estos, podrías usar entry.borderBoxRect o
            entry.devicePixelContentBoxSize, dependiendo de tus necesidades.
             */
            /**
            entry.contentRect.width: Aquí está la clave para obtener el ancho.
            contentRect es un objeto DOMRectReadOnly que contiene información
            sobre el tamaño y la posición del área de contenido del elemento.
            width es la propiedad que te da el ancho de esa área. Es importante
            notar que contentRect excluye el padding, border y scrollbar.
            Si necesitas incluir estos, podrías usar entry.borderBoxRect o
            entry.devicePixelContentBoxSize, dependiendo de tus necesidades.
             */
        }
    }


    private fun getElement(id: String): Element? {
        return document.getElementById(id)
    }


    fun observeElementById(id: String) {
        val element = getElement(id) ?: return // No obtener el elemento si no existe
        resizeObserver.observe(element)
        observers[id] = resizeObserver
    }

    fun unObserveElementById(id: String) {
        observers.remove(id)//?.disconnect()
    }
}


object BorderBoxSizeElementObserver {
    private val widthChangeChannel = MutableSharedFlow<Pair<String, Int>>(replay = 1)  // Canal para comunicar cambios
    val widthChangeFlow = widthChangeChannel.asSharedFlow()

    private val observers = mutableMapOf<String, ResizeObserver>()
    private val resizeObserver : ResizeObserver = ResizeObserver { entries ->
        entries.forEach { entry ->
            CoroutineScope(Dispatchers.Default).launch {
                widthChangeChannel.emit(
                    Pair(entry.target.id,entry.borderBoxSize.first().inlineSize.toInt())
                )
            }

            /**
            entry.contentRect.width: Aquí está la clave para obtener el ancho.
            contentRect es un objeto DOMRectReadOnly que contiene información
            sobre el tamaño y la posición del área de contenido del elemento.
            width es la propiedad que te da el ancho de esa área. Es importante
            notar que contentRect excluye el padding, border y scrollbar.
            Si necesitas incluir estos, podrías usar entry.borderBoxRect o
            entry.devicePixelContentBoxSize, dependiendo de tus necesidades.
             */
            /**
            entry.contentRect.width: Aquí está la clave para obtener el ancho.
            contentRect es un objeto DOMRectReadOnly que contiene información
            sobre el tamaño y la posición del área de contenido del elemento.
            width es la propiedad que te da el ancho de esa área. Es importante
            notar que contentRect excluye el padding, border y scrollbar.
            Si necesitas incluir estos, podrías usar entry.borderBoxRect o
            entry.devicePixelContentBoxSize, dependiendo de tus necesidades.
             */
        }
    }


    private fun getElement(id: String): Element? {
        return document.getElementById(id)
    }


    fun observeElementById(id: String) {
        val element = getElement(id) ?: return // No obtener el elemento si no existe
        resizeObserver.observe(element)
        observers[id] = resizeObserver
    }

    fun unObserveElementById(id: String) {
        observers.remove(id)//?.disconnect()
    }

}


//val contentRectWidthElementObserver = ContentRectWidthElementObserver
//
//object ContentRectWidthElementObserver {
//    //        private val anchoCambioChannel = Channel<Pair<String, Int>>(Channel.BUFFERED) // Canal para comunicar cambios
//    //        val widthChangeFlow = widthChangeChannel.receiveAsFlow()
//
//    private val widthChangeChannel = MutableSharedFlow<Pair<String, Int>>(replay = 1)  // Canal para comunicar cambios
//    val widthChangeFlow = widthChangeChannel.asSharedFlow()
//
//    private val observers = mutableMapOf<String, ResizeObserver>()
//    private val resizeObserver : ResizeObserver = ResizeObserver { entries ->
//        entries.forEach { entry ->
//            CoroutineScope(Dispatchers.Default).launch {
//                widthChangeChannel.emit(
//                    Pair(entry.target.id, entry.contentRect.width.toInt())
//                )
//            }
//
////                widthChangeChannel.trySend(Pair(entry.target.id, entry.contentRect.width.toInt()))
//            /**
//            entry.contentRect.width: Aquí está la clave para obtener el ancho.
//            contentRect es un objeto DOMRectReadOnly que contiene información
//            sobre el tamaño y la posición del área de contenido del elemento.
//            width es la propiedad que te da el ancho de esa área. Es importante
//            notar que contentRect excluye el padding, border y scrollbar.
//            Si necesitas incluir estos, podrías usar entry.borderBoxRect o
//            entry.devicePixelContentBoxSize, dependiendo de tus necesidades.
//             */
//            /**
//            entry.contentRect.width: Aquí está la clave para obtener el ancho.
//            contentRect es un objeto DOMRectReadOnly que contiene información
//            sobre el tamaño y la posición del área de contenido del elemento.
//            width es la propiedad que te da el ancho de esa área. Es importante
//            notar que contentRect excluye el padding, border y scrollbar.
//            Si necesitas incluir estos, podrías usar entry.borderBoxRect o
//            entry.devicePixelContentBoxSize, dependiendo de tus necesidades.
//             */
//        }
//    }
//
//
//    private fun getElement(id: String): Element? {
//        return document.getElementById(id)
//    }
//
//
//    fun observeElementById(id: String) {
//        val element = getElement(id) ?: return // No obtener el elemento si no existe
//        resizeObserver.observe(element)
//        observers[id] = resizeObserver
//    }
//
//    fun unObserveElementById(id: String) {
//        observers.remove(id)//?.disconnect()
//    }
//}

//    object ElementoAnchoObservador {
//        private val anchoCambioChannel = Channel<Pair<String, Int>>(Channel.BUFFERED) // Canal para comunicar cambios
//        val anchoCambioFlow = anchoCambioChannel.receiveAsFlow()
//
//        private val observadores = mutableMapOf<String, ResizeObserver>()
//
//        fun observarElemento(id: String) {
//            if (observadores.containsKey(id)) return // Evitar crear observadores duplicados
//
//            val elemento = document.getElementById(id) as? Element ?: return // Obtener el elemento
//
//
//
//            val resizeObserver = ResizeObserver { entries ->
//                entries.forEach { entry ->
//                    anchoCambioChannel.trySend(Pair(id, entry.contentRect.width.toInt()))
// Accede a borderBoxSize y obtén el primer elemento de la lista
//val borderBoxSize = entry.borderBoxSize.firstOrNull()
//val ancho = borderBoxSize?.inlineSize?.toInt() ?: 0
//
//anchoCambioChannel.trySend(Pair(id, ancho))
//                    /**
//                    entry.contentRect.width: Aquí está la clave para obtener el ancho.
//                    contentRect es un objeto DOMRectReadOnly que contiene información
//                    sobre el tamaño y la posición del área de contenido del elemento.
//                    width es la propiedad que te da el ancho de esa área. Es importante
//                    notar que contentRect excluye el padding, border y scrollbar.
//                    Si necesitas incluir estos, podrías usar entry.borderBoxRect o
//                    entry.devicePixelContentBoxSize, dependiendo de tus necesidades.
//                     */
//                }
//            }
//
//            resizeObserver.observe(elemento)
//            observadores[id] = resizeObserver
//        }
//
//        fun dejarDeObservarElemento(id: String) {
//            observadores.remove(id)?.disconnect()
//        }
//    }